import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { accessToken } from "./welcome_new_project.js";

const ghaOIDCInstructions = (project: WireTypes.Project) => markdown`
  Set the \`FLAKINESS_PROJECT\` environment variable and enable the \`id-token: write\` permission in your workflow:

  ${markdown.yaml(`
    env:
      FLAKINESS_PROJECT: ${project.org.orgSlug}/${project.projectSlug}

    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      - name: Run pytest
        run: pytest
  `, `.github/workflows/tests.yml`, { ins: [[1, 6]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience, and set \`FLAKINESS_PROJECT\` to the project the report uploads to:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      variables:
        FLAKINESS_PROJECT: ${project.org.orgSlug}/${project.projectSlug}
      script:
        - pytest
  `, `.gitlab-ci.yml`, { ins: [[2, 6]] })}
`;

const otherCIInstructions = (project: WireTypes.Project) => markdown`
  Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(project)} and run your tests:

  ${markdown.bash(`
    FLAKINESS_ACCESS_TOKEN=<token> FLAKINESS_PROJECT=${project.org.orgSlug}/${project.projectSlug} pytest
  `)}
`;

export const welcome_pytest = (project: WireTypes.Project) => markdown`

1. Install the Flakiness.io Pytest reporter:

    ${markdown.bash(`
      uv add --dev pytest-flakiness
      # or: pip install pytest-flakiness
    `)}

    The reporter auto-activates once installed.

1. Configure your CI
    ${ciTabs({
      idPrefix: 'pytest',
      project,
      githubActions: ghaOIDCInstructions(project),
      gitlabCI: gitlabOIDCInstructions(project),
      otherCI: otherCIInstructions(project),
    })}
`;
